
import { Offer } from '@/@types/graphql-types';
import { ClickoutUrl } from '@/helpers/clickout-helper';
import {
	SnowplowClickoutContextGraphql,
	SnowplowContext,
	SnowplowTitleContextGraphql,
} from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { TitleDetailsNode } from '@/interfaces/title-details-graphql';
import { OfferPresentationType } from '@/interfaces/titles';
import { Vue, Component, Emit, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const User = namespace('user');

@Component({ name: 'BuyBoxOffer' })
export default class BuyBoxOffer extends Vue {
	@Prop({ required: true }) title: TitleDetailsNode;
	@Prop({ required: true }) offer: Offer;
	@Prop({ default: () => [] }) additionalContexts: SnowplowContext[];

	@User.Getter buyboxPresentationType: OfferPresentationType;

	icons = ['/icon/207360008/s100/netflix.{format}'];
	imageScaler = JW_CONFIG.IMAGESCALER_URL;
	bundleURL = 'https://www.awin1.com/awclick.php?gid=466322&mid=11005&awinaffid=400165&linkid=3414019&clickref=';

	@Emit('visibilityChanged')
	onVisibilityChanged(isVisible: boolean) {
		return isVisible;
	}

	get property() {
		if (this.buyboxPresentationType === null) return OfferPresentationType._4K; //NOTE: for tracking purposes
		return this.buyboxPresentationType;
	}
	get bundleLabelSuffix() {
		switch (this.buyboxPresentationType) {
			case null:
				return '4k';
			case OfferPresentationType._4K:
				return '4k';
			case OfferPresentationType.HD:
				return 'HD';
			default:
				return '';
		}
	}

	get bundleOfferUrl() {
		return new ClickoutUrl({
			standardWebURL: this.bundleURL,
		}).toString();
	}
	get trackingContexts() {
		const titleContext = new SnowplowTitleContextGraphql(
			this.title.objectId,
			this.title.objectType,
			this.title.content.seasonNumber
		);

		return (this.additionalContexts || []).concat([titleContext]);
	}
	clickOut() {
		let contexts: SnowplowContext[] = [];
		const clickoutContext = SnowplowClickoutContextGraphql.fromProviderOffer(this.offer);
		contexts = this.trackingContexts;
		contexts.push(clickoutContext);

		TrackingHelper.trackEvent(
			'clickout',
			{
				action: 'flatrate',
				label: 'Sky Go',
				property: this.property,
				value: 3,
			},
			contexts
		);
	}
}
